export const useTitle = title => {
  if (typeof document === 'undefined') {
    return
  }

  const originalTitle = document.title
  document.title = `${title} | Traede`
}
